
<input :id="formId" v-model="internalValue" type="checkbox" class="toggle">
